import { CartRecommendationsBase } from '@theme/cart-recommendations-base';

/**
 * Cart page recommended products carousel.
 *
 * Extends {@link CartRecommendationsBase} for the track/arrow plumbing. The cards are
 * server-rendered — cross-sells of the cart's products on a filled cart, best sellers
 * on an empty one (see blocks/_cart-recommended-products.liquid) — so this component
 * fetches nothing. Also used by the search zero-results carousel
 * (sections/hydrate-slp-products.liquid), which is likewise server-rendered.
 *
 * Cart-page specifics: arrows are desktop-only (hidden on mobile via CSS) and the
 * unusable edge arrow is fully hidden, not dimmed.
 */
class CartFullRecommendations extends CartRecommendationsBase {
  /**
   * The cart dispatches its update event BEFORE it morphs the section, so the fresh
   * cards (or the removal of this host altogether) have not landed yet. Only the
   * arrows need a recount, once the morph has settled.
   */
  onCartUpdate() {
    requestAnimationFrame(() => this.updateArrows());
  }

  /** Fully hide the arrow that can't be used (no card in that direction). */
  setArrowEdgeState(button, atEdge) {
    button.disabled = atEdge;
    button.style.opacity = atEdge ? '0' : '1';
    button.style.pointerEvents = atEdge ? 'none' : '';
  }
}

if (!customElements.get('cart-full-recommendations')) {
  customElements.define('cart-full-recommendations', CartFullRecommendations);
}
